"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Field_1 = require("./Field");
exports.FieldList = function (props) {
    return react_1.default.createElement(Field_1.Field, __assign(__assign({}, props), { dataType: 'array' }));
};
exports.FieldList.displayName = 'ReactInternalFieldList';
exports.FieldList.defaultProps = {
    path: '',
    triggerType: 'onChange'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/components/FieldList.js
// module id = 4649
// module chunks = 0